export default "__VITE_ASSET__8496d998__"